module.exports = __webpack_public_path__ + "media/Loops 110 Drums.dd039c48.wav";